<script>
    import { res, state, ui, prefs } from './stores.js';
    import { manualCards } from './manual.js';
    import { getCardEffect } from './parse.js';
    import Preview from './Preview.svelte';
    import { toggleSelect } from './ui.js';
    import { parseChunks, pegParse } from './pegparse.js';
    import { get, set } from 'idb-keyval';

    function flatEffects(e){
        if(e.type == 'choice') return e.choices;
        return e;
    }

    let headRow;
    let infoPane
    let verified = {}
    let JSONfilter = false;

    async function getVerifications(){

        for(let c of $res.cards){
            for(let t of $res.possChunks){
                let res = await get(`verified_${c.id}_${t}`);
                if(res){
                    verified[c.id+'_'+t] = res;
                }else{
                    verified[c.id+'_'+t] = false;
                }
            }
        }
    }

    
    
    function translate(){
        var translate = "translate(0,"+infoPane.scrollTop+"px)";
        headRow.style.transform = translate;
    }

    function completePercent(c, log){
        if(log) console.log(c.effect.map(e => flatEffects(e)).flat(3))
        let done = c.effect.flatMap(e => flatEffects(e)).flat(3).filter(e => e.type != 'incomplete').length;
        let total = c.effect.flatMap(e => flatEffects(e)).flat(3).length; 
        if(done == 0) return false;
        return `${done} of ${total}`;
    }

    function title(c, t){
        let e = getCardEffect(c, t);
        if(e) return e.text;
        return '';
    }

    let parsedEffects = 0;
    let totalEffects = 0;
    $: countParsedEffects($res.cards);

    function countParsedEffects(cards){
        let e = [];
        let une = [];
        for(let c of cards){
            let pct = $res.parsedCardText[c.id].effects;
            if(!pct){
                let chunks = parseChunks($res.parsedCardText[c.id].text?.trim());
                if(!chunks.effects){
                    continue;
                }
                for(let t of chunks.effects){
                    if(pegParse(t.text).effects){
                        e.push(t);
                    }else{
                        une.push(t);
                    }
                }
                continue;
            }
            e.push(...pct);
        }
        //console.log(e, une);
        parsedEffects = e.length;
        totalEffects = e.length + une.length;
    }

    function getTextStatus(c, type){
        if(manualCards[c.id] && manualCards[c.id][type]) return 'manual';

        let pc = $res.parsedCardText[c.id].effects;
        if(pc && pc.some(t => t.autoTyped)){
            if(!$ui.autoTyped) $ui.autoTyped = {};
            $ui.autoTyped[c.id] = `${c.name} (${c.id}): ${pc.filter(t => t.autoTyped).map(t => t.text).join(', ')}`;
        }
        if(!pc){
            let chunks = parseChunks($res.parsedCardText[c.id].text);
            //console.log(chunks);
            if(chunks.effects && chunks.effects.some(t => t.type == type)){
                if(chunks.effects.filter(t => t.type == type).every(t => pegParse(t.text).effects)){
                    //console.log(chunks.effects.filter(t => t.type == type).map(t => pegParse(t.text)))
                    return 'done';
                }
                return 'uncoded';
            }
            return 'empty';
        }
        let bit = pc.filter(t => t.type == type)
        for(let e of bit){
            if(e.incomplete){
                let percent = completePercent(e);
                if(percent){
                    return `Incomplete (${completePercent(e)})`; // TODO this doesn't handle multi-action cards yet
                }else{
                    return `uncoded`;
                }
                
            }else{
                return 'done';
            }
        }
        return 'empty'
    }

    function select(c){
        if($ui.selection == c){
            $ui.selection = false;
        }else{
            $ui.selection = c;
        }
        console.log($ui.selection, $res.parsedCardText[c.id]);
        let chunks = parseChunks($res.parsedCardText[c.id].text).effects;
        if(chunks) console.log(chunks, chunks.map(c => pegParse(c.text)));
    }

    function filter(cards, f, ou, _){
        let filtered = [];
        for(let c of cards){
            let pct = $res.parsedCardText[c.id];
            if((pct.text && pct.text.toLowerCase().includes(f.toLowerCase()) || c.name && c.name.toLowerCase().includes(f.toLowerCase())) && !filtered.includes(c) && (!ou || notFullyVerified(c))) filtered.push(c);   
            if(JSONfilter && JSON.stringify(pct).toLowerCase().includes(f.toLowerCase())) filtered.push(c); 
        }
        return filtered;
    }

    function cardComplete(c){
        if($res.possChunks.every(t => getTextStatus(c, t) == 'done' || getTextStatus(c, t) == 'empty' || getTextStatus(c, t) == 'manual')) return true;
        return false;
    }

    function getStats(){
        let complete = $res.cards.filter(c => cardComplete(c)).length;
        let incomplete = $res.cards.length - complete;
        let chunks = {};
        for(let p of $res.possChunks){
            chunks[p] = {
                total: 0,
                complete: 0,
                incomplete: 0
            };
            for(let c of $res.cards){
                let s = getTextStatus(c, p);
                if(s == 'done' || s == 'manual'){
                    chunks[p].total++;
                    chunks[p].complete++;
                }else if(s == 'empty'){
                    continue;
                }else{
                    chunks[p].total++;
                    chunks[p].incomplete++;
                }
            }
        }
        return {
            complete,
            incomplete,
            chunks,
            percent: Math.round(complete / $res.cards.length * 100)
        };
    }

    async function effectVerified(c, t){
        return verified[c.id+'_'+t];
    }

    function toggleVerify(c,t, value = true){
        let v = verified[c.id+'_'+t];
        if(v){
             verified[c.id+'_'+t] = false;
             set(`verified_${c.id}_${t}`, false);
        }else{
             verified[c.id+'_'+t] = value;
             set(`verified_${c.id}_${t}`, value);
        }
    }

    function clickItem(e, c, t){
        if(getTextStatus(c, t) == 'empty') return;
        if(e.shiftKey){
            toggleVerify(c,t);
        }else if(e.metaKey){
            toggleVerify(c,t, 'failed');
        }else{
            select(c); copyText(c, t)
        }
    }

    function copyText(c, type){
        if($res.parsedCardText[c.id].effects && $res.parsedCardText[c.id].effects.some(t => t.type == type)){
            let text = `'${c.id}': {
        name: \`${c.name}\`,
        text: \`${$res.parsedCardText[c.id].text}\`,
        check: (p,m) => {
            return false;
        }
    },`
            navigator.clipboard.writeText(text);
        }
    }

    function exportFullCards(){
        let blob = new Blob([JSON.stringify($res.cards)], { type: 'application/json' });
        let url = URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = `cards_${new Date().toISOString().slice(0,10)}.json`;
        a.click();
        URL.revokeObjectURL(url);
    }

    function copyFilteredCards(){
        let cards = [...filter($res.cards, f, onlyUnverified)].filter(c => c.id).filter(c => !typeFilter || getTextStatus(c, typeFilter) != 'empty').sort((a,b) => a.id.localeCompare(b.id));
        let names = cards.map(c => c.name).join(', ');
        let ids = cards.map(c => c.id).join(', ');

        navigator.clipboard.writeText(`${names} (IDs ${ids})`);
    }
    
    let stats = getStats();
    console.log(Object.values($ui.autoTyped).join('\n'));

    let f = '';
    let typeFilter = null;

    function toggleTypeFilter(t){
        if(typeFilter == t){
            typeFilter = null;
        }else{
            typeFilter = t;
        }
    }

    function totalChunks(stats){
        return Object.keys(stats.chunks).reduce((a,c) => a + stats.chunks[c].total, 0);
    }

    function verifiedPercent(v){
        return Math.round(verifiedNum(v) / totalChunks(stats) * 100);
    }

    function verifiedNum(v){
        let numVer = 0;
        for(let c of $res.cards){
            for(let t of $res.possChunks){
                if(v[c.id+'_'+t]) numVer++;
            }
        }
        return numVer;
    }

    function notFullyVerified(c){
        for(let t of $res.possChunks){
            if(getTextStatus(c,t) != 'empty' && !verified[c.id+'_'+t]) return true;
        }
        return false;
    }

    let onlyUnverified = false;

</script>
    Card parsing status: {stats.percent}% complete ({stats.complete} of {$res.cards.length} cards)
    <br/> Effect parsing status: {Math.round(parsedEffects / totalEffects * 100)}% complete ({parsedEffects} parsed effects of {totalEffects} total)
    <div>
        Filter: <input type="text" bind:value={f} /><button on:click={copyFilteredCards}>Copy filtered cards</button><button on:click={exportFullCards}>Export full cards list</button>
        Percentage of effects verified: {verifiedPercent(verified)}% ({verifiedNum(verified)} of {totalChunks(stats)})
        <input type='checkbox' bind:checked={onlyUnverified} /> Only show unverified cards?
        <input type='checkbox' bind:checked={JSONfilter} /> Filter based on JSON of card too?
    </div>
    <div class="parseinfo" bind:this={infoPane} on:scroll={translate}>
        <table >
            <tr bind:this={headRow}>
                <td class='header'>Name</td><td class='header'>Ref</td>
                {#each $res.possChunks as c}
                    <td class='header' on:click={e => toggleTypeFilter(c)}>{c[0].toUpperCase()}{c.slice(1)} ({stats.chunks[c].complete} of {stats.chunks[c].total})</td>
                {/each}
            </tr>
            {#each [...filter($res.cards, f, onlyUnverified, JSONfilter)].filter(c => !typeFilter || getTextStatus(c, typeFilter) != 'empty').sort((a,b) => a.id.localeCompare(b.id)) as c}
                <tr>
                    <td class="header" on:click={e => {select(c)}}>
                        {c.name}
                        {#if cardComplete(c)}
                            ✅
                        {/if}

                    </td>
                    <td>{c.id}</td>
                    {#each $res.possChunks as t}
                        <td title={title(c, t)} on:click={e => {clickItem(e, c, t)}} class="partial {getTextStatus(c, t)}" style="cursor: pointer;">
                            {#if getTextStatus(c, t) == 'uncoded'}
                                Unparsed
                            {:else if getTextStatus(c, t) == 'done'}
                                Complete
                            {:else if getTextStatus(c, t) == 'manual'}
                                Handcoded
                            {:else if getTextStatus(c, t) == 'empty'}
                            {:else}
                                {getTextStatus(c, t)}
                            {/if}
                            {#if verified[c.id+'_'+t] == true}
                                    ✅
                            {:else if verified[c.id+'_'+t] == 'failed'}
                                    ❌
                            {/if}
                        </td>
                    {/each}
                </tr>
            {/each}
        </table>
    </div>
<Preview force useImages={false}/>
<style>

    .partial {
        background-color: #b36200;
        color: white;
    }
    
    .done {
        background-color: darkgreen;
        color: white;
    }

    .uncoded {
        background-color: darkred;
        color: white;
    }

    td { 
        border: 1px solid white;
    }
    
    table {
        border-collapse: collapse;
    }

    .header {
        background-color: lightgrey;
        color: black;
        font-weight: bold;
        border: 1px solid black;
    }
    
    .parseinfo {
        overflow: auto;
        height: 70vh;
    }

    .manual {
        background-color: purple;
        color: white;
    }

     .empty {
        background-color: black;
    }
</style>